import { useSelector } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import UserCapabilityHelper from 'helpers/userCapabilityHelper';

const useGatewayUserCapability = () => {
    const capability = useSelector(({ powertrainTools }) => powertrainTools?.userCapabilities);
    const isInitialized = useRef(false);

    const [capabilityHelper, setCapabilityHelper] = useState(new UserCapabilityHelper(capability));

    useEffect(() => {
        return () => {
            setCapabilityHelper(null);
        };
    }, []);

    useEffect(() => {
        if (isInitialized.current) {
            setCapabilityHelper(new UserCapabilityHelper(capability));
        } else {
            isInitialized.current = true;
        }
    }, [capability]);

    return capabilityHelper;
};

export default useGatewayUserCapability;
